import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './main.css'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
    faAward,
    faBars,
    faBookOpen,
    faCalendar,
    faHeartPulse,
    faLaptopCode,
    faLocationDot,
    faMoneyBillWave,
    faMoneyCheckDollar,
    faPiggyBank,
    faRoad,
    faSpa, 
    faUmbrellaBeach, 
    faUpRightFromSquare, 
    faUserGraduate,
    faUserPlus,
    faXmark} from '@fortawesome/free-solid-svg-icons'
import { 
    faClock } from '@fortawesome/free-regular-svg-icons'

library.add(
    faHeartPulse,
    faPiggyBank,
    faMoneyCheckDollar,
    faAward,
    faUmbrellaBeach,
    faSpa,
    faLocationDot,
    faClock,
    faUserPlus,
    faXmark,
    faUpRightFromSquare,
    faBars,
    faMoneyBillWave,
    faUserGraduate,
    faBookOpen,
    faCalendar,
    faLaptopCode,
    faRoad
    )


const app = createApp(App)
  .use(router)
  .use(VueAxios, axios)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')
